import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "./context/AppContext";
interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [loading, setLoading] = useState(true);
  const [isSessionValid, setIsSessionValid] = useState(false);
  const { userData, setAccessToken, setUserData } = useAppContext();
  useEffect(() => {
    const validateToken = async () => {
      setLoading(true);
      try {
        const accounts = instance.getAllAccounts();
        if (accounts.length === 0) {
          setIsSessionValid(false);
          setLoading(false);
          return;
        }
        const OUTLOOK_API_SCOPE = process.env
          .REACT_APP_OUTLOOK_API_SCOPE as string;
        console.log(OUTLOOK_API_SCOPE);
        const tokenResponse = await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: [OUTLOOK_API_SCOPE],
        });

        console.log("NToken:", tokenResponse);

        setAccessToken(tokenResponse.accessToken);
        const tokenExpiry = tokenResponse.expiresOn?.getTime() || 0;
        if (tokenExpiry > Date.now()) {
          setIsSessionValid(true);
        } else {
          console.warn("Token expired. Attempting refresh...");
          const refreshedTokenResponse = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: [OUTLOOK_API_SCOPE],
            forceRefresh: true,
          });
          setAccessToken(refreshedTokenResponse.accessToken);
          setIsSessionValid(true);
        }
      } catch (error) {
        console.error("Token acquisition failed: ", error);
        setIsSessionValid(false);
      }
      setLoading(false);
    };

    validateToken();
  }, [instance]);

  useEffect(() => {
    if (userData) {
      localStorage.setItem("userData", JSON.stringify(userData));
    }
  }, [userData]);
  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Optional: Add a spinner or placeholder
  }

  if (
    !isAuthenticated ||
    !isSessionValid ||
    !userData ||
    (userData.roleID !== 1 && userData.roleID !== 3)
  ) {
    return <Navigate to="/login" />;
  }
  return <>{element}</>;
};

export default ProtectedRoute;
